/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Modal, Button } from '@atoms';
import { TextField, LocationField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { Form } from '@organisms';
import RichTextField from '@molecules/RichTextField';
import MediaField from '@organisms/MediaField';
import { useLocation } from '@api/hooks';

import { LOCATION_FORM_FIELD } from './constants';

const LocationFormModal = ({ initialValues: _initialValues, onSubmit, hide, visible }) => {
  const [form] = Form.useForm(LOCATION_FORM_FIELD);

  const locationQuery = useLocation({ id: _initialValues?.locationId });
  React.useEffect(() => {
    if (visible && locationQuery.status === 'success') {
      form.setFieldsValue({ [LOCATION_FORM_FIELD.LOCATION.name]: locationQuery.data });
    }
  }, [locationQuery.article, locationQuery.data, locationQuery.status, form, visible]);

  React.useEffect(() => {
    const deserialized = form.deserialize(_initialValues);
    form.setFieldsValue(deserialized);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const handleCancel = () => {
    form.resetFields();
    hide();
  };

  const handleOk = async () => {
    try {
      const data = await form.remoteSubmit();
      await onSubmit(data);
      form.resetFields();
      hide();
    } catch (e) {
      console.log(e);
    }
  };

  const footer = (
    <>
      <Button key="submit" type="customBlue" onClick={handleOk}>
        ADD LOCATION
      </Button>

      <Button key="back" onClick={handleCancel}>
        CANCEL
      </Button>
    </>
  );

  return (
    <Modal disableTitle visible={visible} footerDivider={false} footer={footer}>
      <Form form={form} labelAlign="left" layout="vertical" colon={false} style={{ marginTop: 20 }}>
        <LocationField
          {...LOCATION_FORM_FIELD.LOCATION}
          disabled={locationQuery.isFetching}
          extra={null}
          wrapperCol={{ span: 24 }}
        />
        <TextField {...LOCATION_FORM_FIELD.HEADLINE} />
        {/* Stupid adhoc for https://jira7.haynet.com:8443/browse/WACMSV2-736 */}
        {visible && <RichTextField {...LOCATION_FORM_FIELD.DESCRIPTION} />}
        <TextField {...LOCATION_FORM_FIELD.LINK} />
        <MediaField {...LOCATION_FORM_FIELD.IMAGE} style={NO_MARGIN_BOTTOM} />
      </Form>
    </Modal>
  );
};

export default LocationFormModal;
